import { MenuItem, TextField, Typography } from "@material-ui/core"
import * as React from "react"
import { CCUtils, NumberMaybe } from "../../common/CCUtils"
import { dayNumbers, Month, MonthMaybe } from "../../common/TimeUtils"
import { appTheme } from "../StyleUtils"

export interface BirthdayPickerProps {
    handleUpdate: (event: React.ChangeEvent<HTMLInputElement>) => void
    birthMonth: MonthMaybe
    birthDay: NumberMaybe
}

export const BirthdayPicker: React.FC<BirthdayPickerProps> = ({handleUpdate, birthDay, birthMonth}) => {

    return (
        <>
            <Typography variant={"body2"} style={{margin: appTheme.spacing(2, 0), alignSelf: "start"}}>What is Your Birthday</Typography>
            <div style={{display: "flex", width: "100%"}}>
                <TextField
                    onChange={handleUpdate}
                    label={"Month"}
                    name={"birthMonth"}
                    value={birthMonth ? birthMonth : ""}
                    fullWidth={true}
                    style={{marginRight: appTheme.spacing(2)}}
                    select={true}
                    required={true}
                >
                    {CCUtils.enumValues(Month).map(month => (
                        <MenuItem key={month} value={month}>
                            {month}
                        </MenuItem>
                    ))}
                </TextField>
                <TextField
                    onChange={handleUpdate}
                    label={"Day"}
                    name={"birthDay"}
                    value={birthDay ? birthDay : ""}
                    fullWidth={true}
                    select={true}
                    required={true}
                >
                    {dayNumbers.map(day => (
                        <MenuItem key={day} value={day}>
                            {day}
                        </MenuItem>
                    ))}
                </TextField>
            </div>
        </>
    )
}